import { render, staticRenderFns } from "./AuditsTable.vue?vue&type=template&id=0793e1fc"
import script from "./AuditsTable.vue?vue&type=script&lang=js"
export * from "./AuditsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports